/** 等待请求层成功提示的页面级兜底判定。 */
type PendingFallback = { timer: number; show: () => void };
const pendingFallbacks: PendingFallback[] = [];
export const REQUEST_SUCCESS_FALLBACK_KEY = "request-success-fallback";
const REQUEST_SUCCESS_FALLBACK_DURATION_MS = 3000;
let requestSuccessFallbackVisibleUntil = 0;

/** 延迟请求层兜底一个事件循环周期，留给页面 await 回调先发出业务成功提示。 */
export function scheduleSuccessFallback(show: () => void): void {
    const pending: PendingFallback = {
        timer: 0,
        show
    };
    pending.timer = window.setTimeout(() => {
        const index = pendingFallbacks.indexOf(pending);
        if (index >= 0) pendingFallbacks.splice(index, 1);
        show();
    }, 0);
    pendingFallbacks.push(pending);
}

/** 页面已经发出成功提示时，消费最近一条等待中的请求兜底提示。 */
export function cancelPendingSuccessFallback(): boolean {
    const pending = pendingFallbacks.shift();
    if (!pending) return false;
    window.clearTimeout(pending.timer);
    return true;
}

/** 记录请求兜底 toast 的展示窗口，页面稍后反馈时可复用同一消息槽替换它。 */
export function markRequestSuccessFallbackVisible(): void {
    requestSuccessFallbackVisibleUntil = Date.now() + REQUEST_SUCCESS_FALLBACK_DURATION_MS;
}

/** 取用当前可见的兜底 toast key，避免页面慢速回调时与请求提示叠加。 */
export function consumeVisibleRequestSuccessFallback(): string | undefined {
    if (Date.now() > requestSuccessFallbackVisibleUntil) {
        requestSuccessFallbackVisibleUntil = 0;
        return undefined;
    }
    requestSuccessFallbackVisibleUntil = 0;
    return REQUEST_SUCCESS_FALLBACK_KEY;
}

/** 记录当前页面已显示的成功提示，供请求层判断全局兜底是否仍有必要。 */
export function captureSuccessNotices(root: ParentNode = document): Set<Element> {
    return new Set(root.querySelectorAll(".ant-message-success, .el-message--success, .el-notification--success"));
}

/** 页面业务提示已新增时，请求层不再补发接口成功兜底提示。 */
export function hasNewSuccessNotice(previous: Set<Element>, root: ParentNode = document): boolean {
    return [...root.querySelectorAll(".ant-message-success, .el-message--success, .el-notification--success")].some(
        notice => !previous.has(notice)
    );
}
